import React, { useEffect, useState } from 'react'

interface SwitcherProps {
  value?: boolean
  onChange?: (value: boolean) => void
}

const Switcher: React.FC<SwitcherProps> = ({ value, onChange }) => {
  const [isOn, setIsOn] = useState<boolean>(value !== undefined ? value : false)

  useEffect(() => {
    if (value !== undefined) {
      setIsOn(value)
    }
  }, [value])

  const toggleSwitch = () => {
    if (onChange) {
      onChange(!isOn)
    } else {
      setIsOn(!isOn)
    }
  }

  return (
    <div
      onClick={toggleSwitch}
      className={`flex h-[22px] w-[44px] cursor-pointer items-center rounded-full p-0.5 transition-colors duration-300 ${
        isOn ? 'bg-[#1890FF]' : 'bg-[#BFBFBF]'
      }`}
    >
      <div
        className={`h-[18px] w-[18px] transform rounded-full bg-white shadow-md transition-transform duration-300 ${
          isOn ? 'translate-x-[22px]' : 'translate-x-0'
        }`}
      />
    </div>
  )
}

export default Switcher
